// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';

/**
 * Global app footer. Pinned to the bottom edge of the window on every page —
 * it lives outside the scrolling main area, so page content scrolls behind it
 * rather than pushing it down the page.
 */
export default function HeliosFooter() {
  return (
    <footer className="helios-footer">
      <span>© 2026 Energy Fluo. All rights reserved.</span>
    </footer>
  );
}
